export default "__VITE_ASSET__B5ae45nV__"